export default "__VITE_ASSET__BGUNL0Jt__"